import { useEffect, useState } from 'react';
import { ArrowLeft, Lock } from 'lucide-react';
import { t, subscribeLanguage } from '../i18n';
import { WORLDS } from '../game/config';
import { isWorldUnlocked } from '../game/systems/progress';

export default function WorldSelect({ onBack, onSelectWorld }) {
  const [, force] = useState(0);
  useEffect(() => subscribeLanguage(() => force((n) => n + 1)), []);

  return (
    <div data-testid="world-select" className="neon-screen">
      <div className="neon-ocean-bg neon-ocean-bg-dim" />
      <div className="neon-worlds-content">
        <button data-testid="btn-back" onClick={onBack} className="neon-btn neon-btn-ghost neon-btn-back">
          <ArrowLeft size={18} />
          <span>{t('common.back')}</span>
        </button>

        <header className="neon-worlds-header">
          <h2 className="neon-worlds-title">{t('worlds.title')}</h2>
          <p className="neon-worlds-subtitle">{t('worlds.subtitle')}</p>
        </header>

        <div className="neon-worlds-grid">
          {WORLDS.map((w, idx) => {
            const unlocked = isWorldUnlocked(w.id);
            return (
              <button
                key={w.id}
                data-testid={`world-card-${w.id}`}
                onClick={() => unlocked && onSelectWorld(w.id)}
                disabled={!unlocked}
                className={`neon-world-card ${unlocked ? 'neon-world-unlocked' : 'neon-world-locked'}`}
                style={{ animationDelay: `${idx * 80}ms` }}
              >
                <div className="neon-world-orb">
                  <span className="neon-world-orb-inner" />
                </div>
                <div className="neon-world-body">
                  <div className="neon-world-name">{t(w.nameKey)}</div>
                  {unlocked ? (
                    <div className="neon-world-status">{t('worlds.unlocked')}</div>
                  ) : (
                    <div className="neon-world-status neon-world-locked-status">
                      <Lock size={14} /> {t('common.locked')}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
